/** @format */
import styled from 'styled-components';

import { StyledVideoBlock } from '../video-block.styles';

export const StyledVideoBlockSkeleton = styled(StyledVideoBlock)`
    .video-skeleton {
        width: 100%;
        height: 100%;
    }
`;
